export default __webpack_public_path__ + "static/media/Macbook-QueryIt.4d69955a.png";